export const getOptionLabel = ({ name }) => name

export const getOptionValue = ({ id }) => id
